export default {
  BUSTURN: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  BUSSTOP: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  BUSBAY: [
    { KEY: 1, VALUE: 'ATIVA' },
    { KEY: 0, VALUE: 'INATIVA' },
  ],
  SPECIAL_BUS_STOP: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  VISIBLE_STOP: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
  COVERED: [
    { KEY: 1, VALUE: 'SIM' },
    { KEY: 0, VALUE: 'NÃO' },
  ],
};

const CONST_STOPS_OBJECT = {
  BUSTURN: {
    YES: { KEY: 1, VALUE: 'SIM' },
    NO: { KEY: 0, VALUE: 'NÃO' },
  },
  BUSSTOP: {
    YES: { KEY: 1, VALUE: 'SIM' },
    NO: { KEY: 0, VALUE: 'NÃO' },
  },
  BUSBAY: {
    YES: { KEY: 1, VALUE: 'SIM' },
    NO: { KEY: 0, VALUE: 'NÃO' },
  },
  SPECIAL_BUS_STOP: {
    YES: { KEY: 1, VALUE: 'SIM' },
    NO: { KEY: 0, VALUE: 'NÃO' },
  },
  COVERED: {
    YES: { KEY: 1, VALUE: 'SIM' },
    NO: { KEY: 0, VALUE: 'NÃO' },
  },
};

export { CONST_STOPS_OBJECT };
